import { Button } from '@/components/ui/button';
import { toast } from '@/hooks/use-toast';
import { revokeMfaTotpMutationFn } from '@/lib/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { Loader } from 'lucide-react';
import React from 'react';

const RevokeMfa = () => {
    const queryClient = useQueryClient();

    const { mutate, isPending } = useMutation({
        mutationFn: revokeMfaTotpMutationFn,
        onSuccess: (response: AxiosResponse) => {
            queryClient.invalidateQueries({
                queryKey: ['authUser'],
            });
            toast({
                title: 'Success',
                description: response.data.message,
            });
        },
        onError: (error) => {
            toast({
                title: 'Error',
                description: error.message,
                variant: 'destructive',
            });
        },
    });

    const handleClick = React.useCallback(() => {
        mutate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className='flex flex-col md:flex-row items-center gap-2'>
            <Button
                disabled={isPending}
                className='h-[35px] !text-[#c40006d3] !bg-red-100 shadow-none mr-1'
                onClick={handleClick}>
                {isPending && <Loader className='animate-spin' />}
                Revoke TOTP
            </Button>
            <p className='text-muted-foreground text-sm text-center'>
                Not recommended to revoke TOTP for security reasons and
                protection from lockout.
            </p>
        </div>
    );
};

export default RevokeMfa;
